import React, { useRef } from "react";
import PosterCard from "@/components/film/PosterCard";
import { Navigation, Thumbs, FreeMode, Pagination } from "swiper/modules";
import ReactMarkdown from "react-markdown";
import { Swiper, SwiperSlide } from "swiper/react";
import breakpoints from "@/constants/breakpoinst";
import * as Text from "@/components/text";
import classNames from "classnames";
import useWindowSize from "@/hooks/useWindowSize";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import { getStrapiImage } from "@/utils/strapiFunctions";


import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";

export default function MoviesCatalog({
  movies = [],
  title = "",
  description = "",
  selectedCategory,
  categories= [],
  onSelectedCategory,
  ...rest
}) {

  // Get default category (first item) if none selected
  const defaultCategory = categories[0]?.slug || '';
  const activeCategory = selectedCategory || defaultCategory;

  // Filter movies by active category
  const filteredMovies = movies.filter(movie => 
    movie.attributes.secciones?.data?.some(
      section => section.attributes.slug === activeCategory
    )
  );
  
  const windowSize = useWindowSize();
  const beforeRef = useRef(null);
  const afterRef = useRef(null);
  const paginationRef = useRef(null);
  return (
  //   <div {...rest} className="w-full ">

  //     <div className="mb-8 flex items-center justify-center align-middle ">
  //       <div className="flex grow flex-col ">
  //         <div className="space-y-3">
  //           <Text.Headline
  //             size="sm"
  //             className="inline-flex text-neutral-900 md:hidden"
  //           >
  //             {title}
  //           </Text.Headline>
  //           <div className="flex">
  //             <Text.Display
  //               size="sm"
  //               className="hidden text-neutral-900  md:flex"
  //             >
  //               {title}
  //             </Text.Display>
  //             <Text.Display
  //               as="span"
  //               size="sm"
  //               className="ml-5 hidden text-neutral-400 md:inline-flex"
  //               fontWeight="light"
  //             >
  //               ({movies.length})
  //             </Text.Display>
  //           </div>

  //           <div className="max-w-lg">
  //             <ReactMarkdown className={"prose mb-6 prose-h2:uppercase"}>
  //               {description}
  //             </ReactMarkdown>
  //           </div>
  //         </div>
  //       </div>

  //       <div className="hidden flex-row-reverse items-center gap-2 py-5  md:flex">
  //         <button ref={afterRef} className="border-neutral-900/36 border p-2">
  //           <ArrowRightIcon className="h-5 w-5" />
  //         </button>
  //         <div className="flex gap-5" ref={paginationRef}></div>
  //         <button ref={beforeRef} className="border-neutral-900/36 border p-2">
  //           <ArrowLeftIcon className="h-5 w-5" />
  //         </button>
  //       </div>
  //     </div>

  //     <Swiper
  //       slidesPerView={1}
  //       breakpoints={{
  //         [breakpoints.xl]: {
  //           slidesPerView: 5,
  //           slidesPerGroup: 5,
  //           spaceBetween: 24,
  //         },
  //         [breakpoints.lg]: {
  //           slidesPerView: 4,
  //           slidesPerGroup: 4,
  //           spaceBetween: 24,
  //         },
  //         [breakpoints.md]: {
  //           slidesPerView: 3.2,
  //           slidesPerGroup: 3,
  //           spaceBetween: 24,
  //         },
  //         [breakpoints.sm]: {
  //           slidesPerView: 2.2,
  //           slidesPerGroup: 2,
  //           spaceBetween: 16,
  //         },
  //       }}
  //       modules={[Thumbs, Navigation, Pagination]}
  //       navigation={{
  //         enabled: true,
  //         nextEl: afterRef.current,
  //         prevEl: beforeRef.current,
  //         hiddenClass: "hidden",
  //         disabledClass: "text-neutral-50 border-neutral-50",
  //       }}
  //       pagination={{
  //         clickable: true,
  //         type: "bullets",
  //         el: paginationRef.current,
  //         currentClass: "bg-neutral-900",
  //         bulletClass: "block w-6 h-1 bg-neutral-50 ",
  //         bulletActiveClass: "bg-neutral-900",
  //       }}
  //     >
  //       {movies.map((movie) => (
  //         <SwiperSlide key={movie.id}>
  //           <PosterCard
  //             grid_details={true}
  //             theme="light"
  //             slug={`/catalogo/${movie?.attributes.filmSlug}`}
  //             film_image={
  //               movie?.attributes.film_cover_image?.data?.attributes.url
  //             }
  //             size={
  //               windowSize.width > breakpoints.xl
  //                 ? "xl"
  //                 : windowSize.width > breakpoints.lg
  //                   ? "lg"
  //                   : windowSize.width > breakpoints.md
  //                     ? "md"
  //                     : windowSize.width > breakpoints.sm
  //                       ? "sm"
  //                       : "sm"
  //             }
  //             film_original_title={movie?.attributes.film_original_title}
  //             film_name={movie?.attributes.film_name}
  //             film_directors={movie?.attributes.Directores.map(
  //               (d) => d.Director
  //             )}
  //             film_synopsis={movie?.attributes.film_excerpt}
  //             film_streaming_link={movie?.attributes.film_stream_link}
  //             film_metadata={{
  //               year: movie?.attributes?.film_year[0]?.year || "",
  //               duration: movie?.attributes.film_length,
  //               countries: movie?.attributes.countries.map((c) => c.countries),
  //               // languages: movie.post_meta._amb_idioma,
  //             }}
  //           />
  //         </SwiperSlide>
  //       ))}
  //     </Swiper>
  //   </div>
  // );
   <div {...rest} className="w-full">
      {/* Header Section */}
      {title && (
        <div className="mx-auto flex max-w-[974px] flex-col sm:w-[328px] sm:flex-col md:w-full md:flex-row">
          <div className="flex w-full flex-col bg-white sm:w-[328px] sm:text-center md:w-full md:text-left lg:h-full lg:w-full">
            <span className="w-full font-bold leading-10 sm:text-[28px] md:text-[32px] lg:pb-4 lg:text-4xl">
              {title}
            </span>
            {description && (
              <ReactMarkdown className="leading-6 sm:mb-8 sm:text-base md:mb-10 lg:mb-8 lg:text-lg">
                {description}
              </ReactMarkdown>
            )}
          </div>
        </div>
      )}

      {/* Grid Layout */}
      <div className="mx-auto grid max-w-[974px] grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {movies.map((movie) => (
          <div key={movie.id} className="w-full">
            <PosterCard
              grid_details={true}
              theme="light"
              slug={`/catalogo/${movie?.attributes.filmSlug}`}
              film_image={getStrapiImage(movie?.attributes.film_cover_image, "small")}
              film_original_title={movie?.attributes.film_original_title}
              film_name={movie?.attributes.film_name}
              film_directors={movie?.attributes.Directores.map(
                (d) => d.Director
              )}
              film_synopsis={movie?.attributes.film_excerpt}
              film_streaming_link={movie?.attributes.film_stream_link}
              film_metadata={{
                year: movie?.attributes?.film_year[0]?.year || "",
                duration: movie?.attributes.film_length,
                countries: movie?.attributes.countries.map((c) => c.countries),
              }}
              className="h-full" // Ensure consistent height
            />
          </div>
        ))}
      </div>
    </div>
  );
}
